export default __webpack_public_path__ + "8dd1f3dddb907e2b02d8afe847933f3f.jpg";